// extracted by mini-css-extract-plugin
export default {"wrap":"gK-z","heading":"hK-z","brandPromo":"iK-z"};